module.exports = __webpack_public_path__ + "static/Nataliya-Schweda-Photoschweda-SEO-Optimization-Consulting-7f9d4d470a7a3679fde574ec4d0d1cf9.png";